module.exports = __webpack_public_path__ + "img/restriction-yellow.738d4c05.svg";